
import Typography from '@mui/material/Typography';


export const TextDrugNSAID = () => {

return(
<div>
    
<Typography variant="h6" >
<br />


Non-steroidal anti-inflammatory drugs (NSAIDs) are medicines that are widely used to relieve pain, reduce inflammation, and bring down a high temperature. 
They're often used to relieve symptoms of: headaches. painful periods. sprains and strains. 
<br /><br />
Some commonly used NSAIDs include: aspirin (such as Disprin) ibuprofen (such as Nurofen) naproxen (such as Naprosyn).

<br /><br />
Nonsteroidal anti-inflammatory drugs (NSAIDs) are
among the most commonly used analgesics due to their
lack of addictive potential. However, NSAIDs have the
potential to cause serious gastrointestinal, renal, and
cardiovascular adverse events.<br /><br />

 CYP2C9 polymorphisms
influence metabolism and clearance of several drugs
in this class, thereby affecting drug exposure and
potentially safety. We summarize evidence from the
published literature supporting these associations and
provide therapeutic recommendations for NSAIDs based
on CYP2C9 genotype (updates at www.cpicp gx.org).<br /><br />



Sources: <br /><br />
https://cpicpgx.org/guidelines/cpic-guideline-for-nsaids-based-on-cyp2c9-genotype/ 

</Typography>

</div>

)
}